/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Trial
 */
export interface Trial {
    /**
     * Trial status for this customer. Active trials with no ends_at are unlimited.
     * @type {string}
     * @memberof Trial
     */
    status: TrialStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof Trial
     */
    startedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Trial
     */
    endsAt?: Date | null;
    /**
     * Convenience flag for clients.
     * @type {boolean}
     * @memberof Trial
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Trial
     */
    daysRemaining?: number | null;
}


/**
 * @export
 */
export const TrialStatusEnum = {
    None: 'none',
    Active: 'active',
    Expired: 'expired',
    Canceled: 'canceled'
} as const;
export type TrialStatusEnum = typeof TrialStatusEnum[keyof typeof TrialStatusEnum];


/**
 * Check if a given object implements the Trial interface.
 */
// @ts-ignore
export function instanceOfTrial(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

// @ts-ignore
export function TrialFromJSON(json: any): Trial {
    return TrialFromJSONTyped(json, false);
}

// @ts-ignore
export function TrialFromJSONTyped(json: any, ignoreDiscriminator: boolean): Trial {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'startedAt': !exists(json, 'started_at') ? undefined : (json['started_at'] === null ? null : new Date(json['started_at'])),
        'endsAt': !exists(json, 'ends_at') ? undefined : (json['ends_at'] === null ? null : new Date(json['ends_at'])),
        'isActive': !exists(json, 'is_active') ? undefined : json['is_active'],
        'daysRemaining': !exists(json, 'days_remaining') ? undefined : json['days_remaining'],
    };
}

// @ts-ignore
export function TrialToJSON(value?: Trial | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'started_at': value.startedAt === undefined ? undefined : (value.startedAt === null ? null : value.startedAt.toISOString()),
        'ends_at': value.endsAt === undefined ? undefined : (value.endsAt === null ? null : value.endsAt.toISOString()),
        'is_active': value.isActive,
        'days_remaining': value.daysRemaining,
    };
}

